import React, { useState, useEffect, useCallback } from 'react';

const slidesData = [
  { src: "/img/mockups/menu_screenshots/Different Game Types.png", title: "Different Game Types" },
  { src: "/img/mockups/menu_screenshots/Very customizable.png", title: "Very Customizable" },
  { src: "/img/mockups/multiway_rangeviewer_screenshots/Multiway Range Viewer.png", title: "Multiway Range Viewer" },
  { src: "/img/mockups/simple_rangeviewer_screenshots/Super Fast Range Viewer.png", title: "Super Fast Range Viewer" },
  { src: "/img/mockups/statistics_screenshots/User Feedback.png", title: "User Feedback" },
  { src: "/img/mockups/trainer_screenshots/Fun Preflop Trainer.png", title: "Fun Preflop Trainer" }
];

const ScreenshotsSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentTitle, setCurrentTitle] = useState(slidesData[0].title);
  const [titleAnimationClass, setTitleAnimationClass] = useState('');

  const handleIndicatorClick = (index) => {
    setCurrentIndex(index);
  };

  const advanceSlide = useCallback(() => {
    setCurrentIndex(prevIndex => (prevIndex + 1) % slidesData.length);
  }, []);

  useEffect(() => {
    // Title update and animation
    // Animate out
    setTitleAnimationClass('slide-out'); 
    
    const PEEK_DURATION = 100; // ms, time for title to be briefly gone or at edge
    const SLIDE_DURATION = 400; // ms, should match CSS transition for title

    // Wait for slide out animation to mostly complete, then change title and slide in
    const titleTimer = setTimeout(() => {
      setCurrentTitle(slidesData[currentIndex].title);
      setTitleAnimationClass('slide-in');
      // Reset class after animation so it can be re-triggered
      const resetTimer = setTimeout(() => setTitleAnimationClass(''), SLIDE_DURATION);
      return () => clearTimeout(resetTimer);
    }, PEEK_DURATION + 50); // 50ms buffer

    return () => clearTimeout(titleTimer);
  }, [currentIndex]);

  useEffect(() => {
    const autoAdvanceInterval = setInterval(() => {
      if (document.visibilityState === 'visible') { // Only advance if tab is visible
        advanceSlide();
      }
    }, 3000); // Change slide every 3 seconds

    return () => clearInterval(autoAdvanceInterval); // Cleanup on component unmount
  }, [advanceSlide]);

  // CSS for title animation (could be in a .css file too)
  const titleStyle = { }; // placeholder, actual animation is via class
  const titleTextClass = `carousel-title-text ${titleAnimationClass}`;

  return (
    <section className="screenshots-section">
      <style>
        {`
          .carousel-title-text.slide-out {
            transform: translateX(100%);
            opacity: 0;
          }
          .carousel-title-text.slide-in {
            transform: translateX(-100%); /* Start from other side */
            opacity: 0;
            transition: none; /* Jump to start position */
          }
          .carousel-title-text.slide-in.animate {
             transform: translateX(0%); /* Animate to center */
             opacity: 1;
             transition: transform 0.4s ease-in-out, opacity 0.4s ease-in-out;
          }
        `}
      </style>
      <div className="container">
        {/* <h2>App Screenshots</h2>  The original index.html had an h2 in a different section, but it makes sense here too. Keeping it commented for now. */}
        <div className="carousel-container">
          <div className="carousel" style={{ transform: `translateX(-${currentIndex * 100}%)` }}>
            {slidesData.map((slide, index) => (
              <div className="carousel-slide" key={index}>
                <img src={slide.src} alt={slide.title} loading="lazy" />
              </div>
            ))}
          </div>
          <div className="carousel-title-container">
            {/* The span will be re-rendered on title change, let's manage animation with a key or classes */}
            <span className={titleTextClass} style={titleStyle} key={currentTitle}>
              {currentTitle}
            </span>
          </div>
        </div>
        <div className="carousel-indicators">
          {slidesData.map((slide, index) => (
            <button 
              type="button"
              aria-label={`Go to slide ${index + 1}`}
              className={`carousel-indicator ${index === currentIndex ? 'active' : ''}`}
              key={index}
              data-index={index} 
              onClick={() => handleIndicatorClick(index)}
            ></button>
          ))}
        </div>
        <p className="screenshot-description">Swipe through to see different features of the app</p>
      </div>
    </section>
  );
};

export default ScreenshotsSection; 